<div class="rfq-lot-form">
  <h2 mat-dialog-title>
    Create a new Lot

    <button mat-dialog-close aria-label="Close dialog" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content [formGroup]="form">
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="lum-label"
            >Lot Number (<small class="text-warning"
              >System will generate a unique lot number if this is empty.</small
            >)</label
          >
          <input class="lum-input" formControlName="lotNumber" type="text" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="lum-label">Production Date</label>
          <input class="lum-input" type="date" formControlName="productionDate" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label class="lum-label">Expiry Date</label>
          <input class="lum-input" formControlName="expiryDate" type="date" />
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      mat-dialog-close
    >
      Cancel
    </button>
    <button (click)="onSubmit()" [disabled]="submitting" class="lum-button">
      Save
    </button>
  </mat-dialog-actions>
</div>
